import { AgxEmptyState } from '@urbanx/agx.ui-components2'
import { FinanceMenu, MenuTitles } from 'constants/menu'
import { ContentLayout } from 'layout'

const VpaPage = () => {
  return (
    <ContentLayout
      hasSecondaryMenu={false}
      secondaryActiveMenu={MenuTitles.FINANCE_VPA}
      secondaryMenuOverride={FinanceMenu}
      isCampaigns={true}
      tertiaryMenu={[]}
      tertiaryActiveMenu={MenuTitles.FINANCE_VPA}
      tertiaryTitle={'VPA'}
    >
      <AgxEmptyState label="Coming soon" variant="minimal" />
    </ContentLayout>
  )
}

export default VpaPage
